import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { GroupType, GroupTypePairs, toString as toStringGroupType } from "../../../types/models/GroupType.d";

















import { PrimaryMembersGroup } from "../../../../auth/types/models/MembersGroup";

import MembersGroupFormSelect from "../../../../auth/components/membersGroup/MembersGroupForm/MembersGroupFormSelect";



import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";











export const initialFormStateFn = () => { return {
    
        
        name: "",
        
    
        
        description: "",
        
    
        
        groupType: "",
        
    
        
        parentId: null,
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.parentId = PrimaryMembersGroup.fromQuery(location.state?.membersGroupId) || null;
    

    

    return React.useMemo(() => initialFormState, [
        location.state,
        
        
    ])
}

export const formObject = {
    
    
        name:
        string()
        .trim()
        .min(1, msg`Name is required`),
    
    
        description:
        string()
        .trim()
        .nullish(),
    
    
        groupType:
        string()
        .trim()
        .min(1, msg`Group Type is required`),
    
    
        parentId:
        string()
                .nanoid(msg`Parent is required`)
                .nullish(),
    
};

export const formSchema = object(formObject);

const MembersGroupAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'name' }
       aria-label="name"
       data-testid="name"
       label={t`Name`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'description' }
       aria-label="description"
       data-testid="description"
       label={t`Description`}
       
       type='text'
       
   />
   
   
           
           
   
    <crudgen.FormSelect
        required
        name={ prefix + 'groupType' }
        aria-label="groupType"
        label={t`Group Type`}
        options={ GroupTypePairs }
        optionLabelMap={ toStringGroupType }
    />
   
   
           
           
   
    
    <MembersGroupFormSelect
        type="dynamicSelect"
        name="parentId"
        label={t`Parent`}
        prefix={prefix}
        required={ false }
    />
   
   
   
           
        </Container>
    )
}

export default MembersGroupAddForm;
